import { localStorage } from 'kodyl-js/client/web-storage';
import moment from 'moment';
import i18nReducer, { serialize, deserialize } from 'kodyl-js/i18n/redux';

const locales = {
  da: require('../../../locales/da/translation.json'),
  en: require('../../../locales/en/translation.json')
};

const defaultLanguage = localStorage.getItem('language') || 'da';
moment.locale(defaultLanguage);

export default i18nReducer({
  defaultLanguage: defaultLanguage,
  locales,
  onChange(lang) {
    moment.locale(lang);
    localStorage.setItem('language', lang);
  },
  async: '/locales/%s/translation.json'
});

export { serialize, deserialize };
